var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input-number", {
        staticStyle: { width: "50%" },
        attrs: {
          step: 0.5,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.time,
          callback: function ($$v) {
            _vm.time = $$v
          },
          expression: "time",
        },
      }),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: {
            slot: "append",
            placeholder: "请选择",
            disabled: _vm.disabled,
          },
          on: { change: _vm.handleChange },
          slot: "append",
          model: {
            value: _vm.unit,
            callback: function ($$v) {
              _vm.unit = $$v
            },
            expression: "unit",
          },
        },
        [
          _c("el-option", { attrs: { label: "天", value: "D" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "小时", value: "H" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "分钟", value: "M" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }